module.exports = __webpack_public_path__ + "img/1868855943417360.9f963b5d.jpg";